import m from "./../../../dist/es2015/themes/KxyLine.js";
export const am5themes_KxyLine = m;